import React, { FC } from 'react';
import moment from 'moment';

import { fc } from 'i18n';
import { MonitoringDeviceStatuses } from 'types/vehicles-monitoring';

import styles from './styles.module.css';

interface IVehicleStatusCellProps {
  status?: string;
  statusAt?: string;
}

export const VehicleStatusCell: FC<IVehicleStatusCellProps> = ({ status, statusAt }) => {
  if (!status) {
    return fc('unknown');
  }

  if (status === MonitoringDeviceStatuses.Online) {
    return (
      <div className={styles.row}>
        <span className={`${styles.circle} ${styles.online}`} />
        <span>{fc('online')}</span>
      </div>
    );
  }

  if (status === MonitoringDeviceStatuses.Offline) {
    return (
      <div>
        <div className={styles.row}>
          <span className={`${styles.circle} ${styles.offline}`} />
          <span>{fc('offline since')}</span>
        </div>
        {!!statusAt && <div className={styles.date}>{moment(statusAt).format('DD/MM/YYYY, HH:mm:ss')}</div>}
      </div>
    );
  }

  return <div>-</div>;
};
